import React from 'react';
import { ProductSpecs as ProductSpecsType } from '../../types';
interface ProductSpecsProps {
  specs: ProductSpecsType;
}
export function ProductSpecs({
  specs
}: ProductSpecsProps) {
  const specItems = [{
    label: 'Kapacitet',
    value: specs.capacity
  }, {
    label: 'Motor',
    value: specs.motor
  }, {
    label: 'Baterija',
    value: specs.battery
  }, {
    label: 'Vreme punjenja',
    value: specs.chargingTime
  }, {
    label: 'Brzina penjanja',
    value: specs.climbingSpeed
  }, {
    label: 'Dimenzije',
    value: specs.size
  }, {
    label: 'Debljina sklopljeno',
    value: specs.foldingThickness
  }, {
    label: 'Težina',
    value: specs.weight
  }, {
    label: 'Rok isporuke',
    value: specs.leadTime
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-416">
      {specItems.map(item => <div key={item.label} className="bg-dark-surface border-2 border-dark-border rounded-industrial p-4" data-id="element-417">
          <dt className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-1" data-id="element-418">
            {item.label}
          </dt>
          <dd className="text-lg font-bold text-white" data-id="element-419">{item.value}</dd>
        </div>)}
    </div>;
}